import { CaptionStyles, CaptionLineConfig } from '../../types/asset-types';
import { getFontFullPath } from '../../utils/fontUtils';
import { TransitionInEffect } from '../../types/transitions';

const romantic: Partial<CaptionStyles> = {
  theme_preset: 'romantic',
  pageStyle: {
    color: '#000000',
    background: '#ffffffe6',
    borderRadius: '16px',
    paddingLeft: '16px',
    paddingRight: '16px'
  },
  wordStyle: undefined,
  letterStyle: undefined,
  font_location: getFontFullPath('AlexBrush-Regular.ttf'),
  caps: false,
  line_config: CaptionLineConfig.OneLine,
  font_size: 72,
  transitions: {
    pageIn: TransitionInEffect.None
  }
};

export default romantic;
